<template>
  <div>
    <v-card flat>
      <v-sheet min-height="55vh" rounded="lg">
        <div class="pa-2">
          <v-card v-show="isNovo" color="grey lighten-4" outlined white>
            <v-card-text>
            </v-card-text>
            <div v-if="exames.length > 0">
              <v-list-item class="grey lighten-2" v-for="(exame, i) in exames" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="exame"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="exames.splice(i, 1)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
            <v-card-actions>
              <v-text-field v-model="descricao" color="grey darken-3" clearable label="Descrição" type="text"
                v-show="isDescricao"></v-text-field>
              <v-btn :disabled="!descricao" @click="cadastrarSolicitacaoExame()" color="grey darken-3" outlined
                class="ml-2" v-show="isDescricao">
                <v-icon large color="green ligth-2">add</v-icon>
              </v-btn>

              <v-btn :disabled="exames.length == 0" v-show="!isDescricao" color="compleA lighten-3"
                @click="isDescricao = true">
                salvar modelo
                <v-icon right>
                  check_circle_outline
                </v-icon>
              </v-btn>

              <v-spacer></v-spacer>
              <v-btn outlined @click="isNovo = false">
                cancelar
                <v-icon color="compleA lighten-3" right>
                  cancel
                </v-icon>
              </v-btn>
              <v-btn color="primary" @click="salvar(model)">
                imprimir
                <v-icon right>
                  check_circle_outline
                </v-icon>
              </v-btn>
            </v-card-actions>

            <v-divider></v-divider>
            <div class="text-center">
              <v-dialog v-model="dialog" width="600">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mt-2" block outlined color="primary" dark v-bind="attrs" v-on="on">
                    Meus modelos
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title class="text-h5 primary white--text">
                    Meus modelos
                  </v-card-title>

                  <v-virtual-scroll class="mt-2" :bench="0" :items="modelosSolicitacoes" height="250" item-height="64">
                    <template v-slot:default="{ item }">
                      <v-list-item :key="item">
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong>{{ item.nome }}</strong>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-menu bottom left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item v-for="(exame, i) in item.prescricoes" :key="i" @click="() => { }">
                              <v-list-item-title>{{ exame.nome }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-list-item-action>
                          <v-btn :loading="load" icon @click="removerSolicitacao(item)">
                            <v-icon>
                              clear
                            </v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                  </v-virtual-scroll>
                </v-card>
              </v-dialog>
            </div>

          </v-card>
          <v-card v-show="isNovoExame" color="grey lighten-4" outlined white>

            <v-text-field v-model="nomeExame" class="pa-2 mt-5" label="Nome do exame" required>
            </v-text-field>

            <v-alert v-if="successCadastroExame == 1" dense text type="success">
              O exame foi cadastrado com <strong>sucesso</strong>, já pode ser <strong>buscado</strong> na aba anterior!
            </v-alert>

            <v-alert v-if="successCadastroExame == 2" dense outlined type="error">
              Ocorreu um <strong>erro</strong> ao cadastrar o exame
            </v-alert>

            <v-spacer />
            <v-card-actions class="mb-2">
              <v-btn :disabled="!nomeExame" color="success" class="mr-3" outlined
                @click="cadastrarExameMedicoSolicitacao(nomeExame)">

                Cadastrar exame
                <v-icon>
                  done
                </v-icon>
              </v-btn>
              <v-btn outlined @click="isNovoExame = false, nomeExame = '', successCadastroExame = 0">
                cancelar
                <v-icon color="compleA lighten-3" right>
                  cancel
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-show="!isNovo && !isNovoExame" flat>
      <v-card-title class="text-h5">
        Solicitações / Encaminhamentos
        <v-spacer />
        
        <!-- Controle de data -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-switch
              v-model="dataHabilitada"
              hide-details
              class="mt-0"
              v-on="on"
            ></v-switch>
          </template>
          <span>{{ dataHabilitada ? 'Data visível' : 'Data oculta' }}</span>
        </v-tooltip>
        
        <v-icon class="mr-4" v-if="!dataHabilitada">calendar_month</v-icon>
        <v-col cols="4" lg="4" v-else>
          <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                v-model="computedDateFormatted" 
                label="Data"
                persistent-hint 
                prepend-icon="mdi-calendar" 
                readonly 
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-card-title>
      
      <v-divider />

      <v-card-text>
        <!-- Seleção de tipo de exame -->
        <v-item-group v-model="selectedOption" mandatory @change="selectOption">
          <v-container>
            <v-row align="center">
              <v-col v-for="(option, index) in options" :key="index" cols="12" md="5">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-item :value="option.value" v-slot="{ active, toggle }">
                      <v-card 
                        :color="active ? 'primary' : 'grey lighten-2'" 
                        class="d-flex align-center" 
                        height="48" 
                        @click="toggle"
                        v-on="on"
                      >
                        <div class="text-h6 flex-grow-1 text-center">
                          <v-icon class="mr-2" v-text="active ? 'check_circle' : 'radio_button_unchecked'"></v-icon>
                          {{ option.label }}
                        </div>
                      </v-card>
                    </v-item>
                  </template>
                  <span>{{ option.hintMessage }}</span>
                </v-tooltip>
              </v-col>

              <!-- Seleção de pacotes -->
              <v-col cols="12" md="2">
                <v-menu offset-y class="ma-3" :disabled="isLaboratorio == null">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn :loading="isLoading" epressed
                            :color="isLaboratorio != null && pacotes.length > 0 ? 'orange darken-2' : 'grey'" dark
                            v-bind="attrs" v-on="on">
                            <v-icon left>list</v-icon>
                            Pacotes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-for="(item, index) in pacotes" :key="index" @click="solicitacao = item">
                            <v-list-item-title>{{ item.nome }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>

              <v-autocomplete :disabled="isLaboratorio == null" outlined class="mt-0 mt-0" @change="searchExame = ''"
                v-model="exame1" :items="items" :loading="isLoading" :search-input.sync="searchExame" white hide-no-data
                hide-selected item-text="apelido" item-value="API" label="----" placeholder="Buscar exame"
                prepend-icon="mdi-database-search" return-object></v-autocomplete>
            </v-card-text>
            <!-- <v-divider></v-divider> -->
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" v-show="solicitacoesExames.length > 0" @click="solicitacoesExames = []" outlined>
                Limpar
                <v-icon color="primary" left>mdi-broom</v-icon>
              </v-btn>
            </v-card-actions>
            <v-divider />
            <v-card v-if="solicitacoesExames.length > 0" class="mt-2" flat>
              <v-chip v-for="(field, i) in solicitacoesExames" :key="field.idExame" class="ma-1" color="dark" outlined
                close label @click:close="solicitacoesExames.splice(i, 1)">
                <strong> {{ field.apelido }} </strong>
              </v-chip>
            </v-card>
          </v-card>
        </div>
      </v-sheet>
      <v-card-actions>
        <v-spacer />
        <v-btn x-large text color="red" dark @click="$emit('cancelar')">
          <v-icon left>
            cancel
          </v-icon>
          voltar
        </v-btn>
        <v-btn :disabled="solicitacoesExames.length == 0 || isNovo" x-large color="primary"
          @click="addSolicitacoesCard">
          <v-icon left>
            save
          </v-icon>
          Salvar
        </v-btn>

      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogLimpar" width="400">
      <v-card>
        <v-card-title class="text-h5">Confirmar Ação</v-card-title>
        <v-card-text>Você tem certeza que deseja limpar todos os exames?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogLimpar = false">
            Cancelar
          </v-btn>
          <v-btn color="red" text
            @click="isLaboratorio = !isLaboratorio; solicitacoesExames = []; dialogLimpar = false">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Hints Solicitação-->
    <v-dialog v-model="hintBtnDataSolicitacao" max-width="500px" >
        <v-card style="overflow-x:hidden;">
            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                Ocultar data da solicitação.
            <v-spacer/>
            <v-btn icon @click="hintBtnDataSolicitacao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="ma-1">
                Se marcada, a <b>data não será exibida na impressão da solicitação de exames</b>, gerando um documento sem referência temporal.
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="hintExamesLaboratorio" max-width="500px" >
        <v-card style="overflow-x:hidden;">
            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                Filtrar exames laboratoriais.
            <v-spacer/>
            <v-btn icon @click="hintExamesLaboratorio = false"><v-icon color="white">mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="ma-1">
              Exibe <b>apenas exames classificados como laboratoriais</b>, como exames de análises clínicas, bioquímicos, microbiologia e similares.
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="hintExamesRegular" max-width="500px" >
        <v-card style="overflow-x:hidden;">
            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                Filtrar exames não laboratoriais.
            <v-spacer/>
            <v-btn icon @click="hintExamesRegular = false"><v-icon color="white">mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="ma-1">
              Exibe apenas <b>exames que não são laboratoriais</b>, como exames de imagem (RX, USG, Tomografia, Ressonância) e outros procedimentos diagnósticos.
            </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import medicoService from '../../services/medico.service'
import {
  jsPDF
} from 'jspdf'
import {
  applyPlugin
} from 'jspdf-autotable'
applyPlugin(jsPDF)
export default {
  name: 'prescricao',
  props: {
    paciente: {
      type: Object
    },
    isEditSolicitacao: {
      type: Boolean
    },
    isLabAux: {
      type: Boolean
    },
    mExames: []
  },
  data: vm => ({
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    descriptionLimit: 60,
    entries: [],
    dataHabilitada: true,
    load: false,
    dadosProntuario: [],
    isLaboratorio: false, // false = Exames/Consultas
    selectedOption: 0,
    dialog: false,
    isLoading: false,
    dialogLimpar: false,
    isDescricao: false,
    descricao: '',
    solicitacao: [],
    isNovo: false,
    isNovoExame: false,
    pacotes: [],
    modelosSolicitacoes: [],
    mSolicitacoes: [],
    solicitacoesExames: [],
    mPrescricoes: [],
    model: null,
    exames: [],
    examesS: [],
    exame1: '',
    user: null,
    values: null,
    searchExame: null,
    search: null,
    nomeExame: '',
    successCadastroExame: 0,
    options: [
      { label: 'Exames/Consultas', value: true, hintMessage: 'Filtrar exames laboratoriais.' },
      { label: 'Cirurgias', value: false, hintMessage: 'Filtrar exames não laboratoriais.' }
    ],
    hintBtnDataSolicitacao: false,
    hintExamesLaboratorio: false,
    hintExamesRegular: false
  }),

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.filter(entry =>
        !this.solicitacoesExames.some(exame => exame.idExame === entry.idExame)
      ).map(entry => {
        const Description = entry.nome.length > this.nome
          ? entry.nome.slice(0, this.descriptionLimit) + '...'
          : entry.nome
        return Object.assign({}, entry, {
          Description
        })
      })
    }
  },
  methods: {
    selectOption (value) {
      // console.log(value)
      this.isLaboratorio = value
      this.entries = []
      // this.solicitacoesExames = []
      if (value != this.isLaboratorio && this.solicitacoesExames.length > 0) {
        this.dialogLimpar = true
      }
    },
    removerExame (j, i) {
      this.mSolicitacoes[j].prescricoes[i].imprime = !this.mSolicitacoes[j].prescricoes[i].imprime
    },
    addSolicitacoesCard () {
      // console.log(this.isLaboratorio, this.isLabAux)
      if (this.isLaboratorio || this.isLabAux) {
        if (this.isEditSolicitacao) {
          this.$emit('editarSolicitacaoLabCard', { items: this.solicitacoesExames, observacoes: '', isObs: false, data: this.dataHabilitada ? this.formatDate(this.date) : '' })
        } else {
          this.$emit('solicitacoesLabCard', { items: this.solicitacoesExames, observacoes: '', isObs: false, data: this.dataHabilitada ? this.formatDate(this.date) : '' })
        }
      } else {
        if (this.isEditSolicitacao) {
          this.$emit('editarSolicitacaoCard', { items: this.solicitacoesExames, observacoes: '', isObs: false, data: this.dataHabilitada ? this.formatDate(this.date) : '' })
        } else {
          this.$emit('solicitacoesCard', { items: this.solicitacoesExames, observacoes: '', isObs: false, data: this.dataHabilitada ? this.formatDate(this.date) : '' })
        }
      }
    },
    imprimirSolicitacao () {
      let exames = this.solicitacoesExames

      if (exames.length > 0) {
        const doc = new jsPDF()

        doc.text(`Paciente: ${this.paciente.nomePaciente}`, 10, 10)
        doc.text(`Solicitante: ${this.user.nome}`, 10, 17)
        // doc.text(20, 20, 'Paciente: ')
        doc.setFont('courier')

        doc.autoTable({
          columns: [{
            header: 'Exame(s)',
            dataKey: 'nome'
          }],
          body: exames,
          margin: {
            top: 25
          }
        })
        // doc.t('Hello world!', 10, 10)
        doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1)

        // doc.autoPrint()
        window.open(doc.output('bloburl'))
      }
    },

    addSolicitacao_ (data) {
      let isExames = false
      // let exames = []
      this.mSolicitacoes.forEach(s => {
        console.log(s)
        if (s._id === data._id) isExames = true
      })
      if (!isExames) {
        this.mSolicitacoes.push(data)
        for (let i = 0; i < this.mSolicitacoes.length; i++) {
          const s = this.mSolicitacoes[i]
          s.prescricoes.forEach(e => {
            this.mPrescricoes.push(e)
            // this.sExames.push(e)
          })
        }
      }
      this.$emit('solicitacoes', this.solicitacoesExames)
      // this.exame1 = ''
    },
    addSolicitacao (data, tipo) {
      let isExames = false
      if (this.solicitacoesExames.length > 0) {
        if (tipo == 1) {
          var eAux = null
          data.exames.forEach(s => {
            this.solicitacoesExames.forEach(e => {
              eAux = s
              if (e.idExame == s.idExame) isExames = true
            })
            if (!isExames) {
              this.solicitacoesExames.push(eAux)
              isExames = false
            }
          })
        } else {
          this.solicitacoesExames.forEach(s => {
            if (s.idExame == data.idExame) isExames = true
          })
          if (!isExames) {
            this.solicitacoesExames.push(data)
            isExames = true
          }
        }
      }
      if (!isExames) {
        if (tipo == 1) {
          data.exames.forEach(e => {
            console.log(e)
            this.solicitacoesExames.push(e)
          })
        } else {
          this.solicitacoesExames.push(data)
        }
      }
      this.$emit('solicitacoes', this.mSolicitacoes)
    },

    addExame (data) {
      let isExame = false
      this.exames.forEach((e, i) => {
        if (e.idExame == data.idExame) {
          isExame = true
        }
      })
      if (!isExame) {
        this.exames.push(data)
        this.model = null
        this.search = null
      }
    },
    listarExames (nome) {
      this.isLoading = true
      medicoService.medico.listarExamesPorNome(nome, this.isLaboratorio ? 'LABORATORIO' : 'CLINICA').then(r => {
        if (r.status == 200) {
          this.count = r.data.length
          this.entries = r.data
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    removerSolicitacao (solicitacao) {
      this.load = true
      let mExames = []
      this.exames.forEach(e => {
        e.imprime = true
        mExames.push(e)
      })
      medicoService.medico.cadastrarSolicitacaoExame({
        idUsuario: this.user.id,
        solicitacao: solicitacao,
        isRemove: true
      }).then(r => {

      }).finally(() => {
        this.load = false
        this.listarModelosSolicitacoes()
      })
    },
    cadastrarSolicitacaoExame () {
      this.load = true
      let mExames = []
      this.exames.forEach(e => {
        e.imprime = true
        mExames.push(e)
      })
      medicoService.medico.cadastrarSolicitacaoExame({
        idUsuario: this.user.id,

        solicitacao: {
          prescricoes: mExames,
          nome: this.descricao
        },
        isRemove: false
      }).then(r => {
        this.exames = []
        this.descricao = ''
        this.listarModelosSolicitacoes()
      }).finally(() => {
        this.load = false
        this.isNovo = false
      })
    },
    listarPacotes (sadt) {
      this.pacotes = []
      medicoService.medico.buscarPacoteExames(this.user.id != undefined ? this.user.id : this.user._id, sadt,
        this.user.idUnidade != undefined ? this.user.idUnidade : this.user.voucher.idUnidadeNegocio).then(r => {
        if (r.status == 200) {
          this.pacotes = r.data
        }
      })
    },
    listarModelosSolicitacoes () {
      return medicoService.medico.listarSolicitacoesExames(this.user.id).then(r => {
        if (r.status == 200) {
          this.modelosSolicitacoes = r.data
        } else {
          this.modelosSolicitacoes = []
        }
      })
    },
    salvar (data) {
      data.exames = this.values
      this.$emit('addReceita', data)
    },
    cadastrarExameMedicoSolicitacao (nome) {
      console.log(nome)
      medicoService.medico.cadastrarExameMedicoSolicitacao({
        idMedico: this.user.id,
        nome: nome
      }).then(r => {
        console.log('--------: ', r.status)
        if (r.status === 200) {
          this.successCadastroExame = 1
        } else {
          this.successCadastroExame = 2
        }
      }).finally(() => {
        this.nomeExame = ''
      })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    // this.listarPacotes()
    if (this.mExames.length > 0) {
      this.solicitacoesExames = this.mExames
    }
    // Carrega os exames do primeiro option automaticamente


    this.dadosProntuario = this.$store.getters.prontuario
    if (this.dadosProntuario.length > 0) {
      for (let i = 0; i < this.dadosProntuario.length; i++) {
        const d = this.dadosProntuario[i]
        if (this.paciente.idAtendimento == d.idAtendimento) {
          if (d.mSolicitacoes != null) this.mSolicitacoes = d.mSolicitacoes
          break
        }
      }
    }
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    },
    isLaboratorio (val) {
      this.listarPacotes(val)
    },
    solicitacoesExames (val) {
      this.$nextTick(() => {
        this.searchExame = ''
        this.exame1 = ''
      })
    },
    dialog (val) {
      if (val) {
        this.listarModelosSolicitacoes()
      }
    },
    isLabAux (val) {
      this.isLaboratorio = val
    },
    exames (val) {
      if (this.exames.length == 0) this.isDescricao = false
    },
    solicitacao (val) {
      this.addSolicitacao(val, 1)
    },
    exame1 (val) {
      if (val != '') {
        this.addSolicitacao(val, 0)
      }
    },
    model (val) {
      console.log(val)
      if (val != null) {
        this.addExame(val)
      }
    },
    searchExame (val) {
      if (val != null && val != '') {
        this.listarExames(val)
      }
    }
  }
}
</script>
